export default {
  de: {
    name: 'Name',
    create: 'Gemeinde hinzufügen',
  },
};
